import React from 'react';

const SecuritySection = () => {
  const measures = [
    { icon: '🔐', title: 'AES-256 Kryptering', desc: 'All data krypteres i hvile med AES-256 og under overføring med TLS 1.3.' },
    { icon: '🛡️', title: 'Tilgangskontroll', desc: 'Rollebasert tilgangskontroll (RBAC) sikrer at kun autorisert personell har tilgang til persondata.' },
    { icon: '📊', title: 'Revisjonslogger', desc: 'Alle datatilganger logges og overvåkes kontinuerlig for uautorisert aktivitet.' },
    { icon: '🔄', title: 'Sikkerhetskopiering', desc: 'Daglige krypterte sikkerhetskopier lagres i geografisk separerte datasentre i EU.' },
    { icon: '🧪', title: 'Penetrasjonstesting', desc: 'Regelmessige sikkerhetstester utføres av uavhengige tredjeparter to ganger per år.' },
    { icon: '🚨', title: 'Hendelsesrespons', desc: 'Dedikert sikkerhetsteam med 24/7 overvåking og maksimalt 72-timers varslingsfrist ved brudd.' },
  ];

  return (
    <section id="sikkerhet" style={{ marginBottom: '80px' }}>
      {/* Diagonal cut header */}
      <div
        style={{
          background: 'linear-gradient(135deg, #0A1628 0%, #0D1F3C 100%)',
          padding: '48px 40px',
          marginBottom: '40px',
          position: 'relative',
          clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 24px), calc(100% - 24px) 100%, 0 100%)'
        }}
      >
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(4rem, 10vw, 8rem)',
            fontWeight: 900,
            color: 'rgba(59,111,212,0.07)',
            lineHeight: 1,
            position: 'absolute',
            top: '10px',
            right: '20px',
            userSelect: 'none',
            letterSpacing: '-0.04em'
          }}
        >
          03
        </div>
        <div
          style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '0.6875rem',
            color: '#F97316',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            marginBottom: '8px'
          }}
        >
          § 3 — LAGRING & SIKKERHET
        </div>
        <h2
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(1.75rem, 4vw, 3rem)',
            fontWeight: 900,
            color: '#EEF0F2',
            textTransform: 'uppercase',
            letterSpacing: '-0.02em',
            lineHeight: 1,
            marginBottom: '16px'
          }}
        >
          Lagring & Sikkerhetstiltak
        </h2>
        <p
          style={{
            fontFamily: 'Georgia, serif',
            fontSize: '1rem',
            color: 'rgba(238,240,242,0.65)',
            lineHeight: 1.7,
            maxWidth: '600px'
          }}
        >
          Dine personopplysninger lagres på sikre servere innenfor EØS-området, 
          primært via Supabase (EU-region). Vi implementerer tekniske og organisatoriske 
          tiltak i henhold til GDPR artikkel 32.
        </p>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: '16px'
        }}
      >
        {measures?.map((m, i) => (
          <div
            key={i}
            style={{
              background: 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(255,255,255,0.06)',
              padding: '20px',
              display: 'flex',
              gap: '16px',
              alignItems: 'flex-start'
            }}
          >
            <div style={{ fontSize: '1.5rem', flexShrink: 0 }}>{m?.icon}</div>
            <div>
              <div
                style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '0.9375rem',
                  fontWeight: 700,
                  color: '#EEF0F2',
                  marginBottom: '6px'
                }}
              >
                {m?.title}
              </div>
              <p
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.8125rem',
                  color: 'rgba(138,149,163,0.75)',
                  lineHeight: 1.6,
                  margin: 0
                }}
              >
                {m?.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SecuritySection;
